import { render, staticRenderFns } from "./Carry.vue?vue&type=template&id=a8963afe&scoped=true"
import script from "./Carry.vue?vue&type=script&lang=js"
export * from "./Carry.vue?vue&type=script&lang=js"
import style0 from "./Carry.vue?vue&type=style&index=0&id=a8963afe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8963afe",
  null
  
)

export default component.exports